// extracted by mini-css-extract-plugin
export var grid = "hero-module--grid--yYGg4";
export var image = "hero-module--image--wE2lP";
export var hero = "hero-module--hero--JreNK";
export var slogan = "hero-module--slogan--e-J01";
export var arrow = "hero-module--arrow--4zRYG";
export var bouncingArrow = "hero-module--bouncing-arrow--xc1hB";
export var slideSlogan = "hero-module--slide-slogan--wj9pz";
export var sloganContainer = "hero-module--sloganContainer---sbQ0";